import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  inquiryHistoryData: null,
  inquiryLoginData: {
    email: "",
    phone: "",
    select: "852",
  },
  workshopDataById: null,
  userWorkshopId: null,
};

const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    setInquiryHistoryData: (state, action) => {
      state.inquiryHistoryData = action.payload;
    },
    setInquiryLoginData: (state, action) => {
      state.inquiryLoginData = action.payload;
    },
    updateInquiryLoginData: (state, action) => {
      state.inquiryLoginData = {
        ...state.inquiryLoginData,
        ...action.payload,
      };
    },
    setWorkshopDataById: (state, action) => {
      state.workshopDataById = action.payload;
    },
    setUserWorkshopId: (state, action) => {
      state.userWorkshopId = action.payload;
    },
    resetInquiry: () => initialState,
  },
});

export const {
  setInquiryHistoryData,
  setInquiryLoginData,
  updateInquiryLoginData,
  setWorkshopDataById,
  setUserWorkshopId,
  resetInquiry,
} = inquirySlice.actions;

export default inquirySlice.reducer;
